// extracted by mini-css-extract-plugin
module.exports = {"wrap":"VideoDetail_wrap__2Cb5v"};